import { useEffect, useRef } from "react";

const events = ["mousemove", "mousedown", "scroll", "keydown", "touchstart", "wheel"];

export function useInactivity(
  onInactivity: () => void,
  inactivityDelay: number,
  isInactivityModalEnabled: boolean,
  isModalOpened: boolean
) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  // Latest-ref so callers can pass inline arrows without resetting the timer
  // on every parent re-render.
  const onInactivityRef = useRef(onInactivity);
  onInactivityRef.current = onInactivity;

  const millisecondsDelay = inactivityDelay * 1000;

  useEffect(() => {
    if (!isInactivityModalEnabled || isModalOpened) return;

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        onInactivityRef.current();
      }, millisecondsDelay);
    };

    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [isInactivityModalEnabled, isModalOpened, millisecondsDelay]);
}
